 // Common
 export const SET_ERROR = 'setError'
 export const CLEAR_ERROR = 'clearError'
 export const RESET_STATE = 'resetModuleState'

 // Auth
export const PURGE_AUTH = 'logOut'
export const SET_AUTH = 'setUser'